import PropertyListComponent from "../../propertyNew/PropertyListComponent";

const PropertyCustomer = ({ routeBase = "/customer/properties" }) => {
  return (
    <PropertyListComponent
      route={routeBase}
      apiPath="/all/property/latestList"
      method="GET"
      requiresAuth={false}
    />
  );
};

export default PropertyCustomer;
